import gql from 'graphql-tag'
export * as types from './types'

export const notificationAttrsFragment = `
  fragment notificationAttrs on Notification {
    id
    __typename
    type
    createdAt
    aknowledgedAt
    metadata
  }
`

export const lastNotificationsFragment = `
  fragment lastNotifications on UserNotifications {
    notifications(pagination: { first: 5 }) {
      __typename
      edges {
        __typename
        node {
          ...notificationAttrs
        }
      }
    }
  }
`

export const unreadNotificationsFragment = `
  fragment unreadNotifications on UserNotifications {
    unreadNotifications {
      __typename
      totalCount
      edges {
        __typename
        cursor
        node {
          ...notificationAttrs
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`

const NotificationsAPI = {
  fetchAllNotifications: gql`
    query GetNotifications($allNotificationsPagination: PaginationInput) {
      getUsersNotifications {
        id
        __typename
        unreadNotificationsCount
        notifications(pagination: $allNotificationsPagination) {
          totalCount
          edges {
            cursor
            node {
              ...notificationAttrs
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
    ${notificationAttrsFragment}
  `,

  fetchLastFiveNotifications: gql`
    query fetchLastFiveNotifications {
      getUsersNotifications {
        id
        __typename
        unreadNotificationsCount
        ...lastNotifications
      }
    }
    ${lastNotificationsFragment}
    ${notificationAttrsFragment}
  `,

  markNotificationsAsDisplayed: gql`
    mutation markAsDisplayed($notificationIds: [ID!]!) {
      markNotificationsAsDisplayed(notificationIds: $notificationIds) {
        id
        __typename
        displayedAt
        updatedAt
      }
    }
  `,

  acknowledgeNotifications: gql`
    mutation AcknowledgeNotifications($notificationIds: [ID!]!) {
      acknowledgeNotifications(notificationIds: $notificationIds) {
        __typename
        updatedNotifications {
          __typename
          notification {
            id
            __typename
            updatedAt
            aknowledgedAt
          }
        }
        usersNotifications {
          id
          __typename
          unreadNotificationsCount
        }
      }
    }
  `,
  unacknowledgeNotifications: gql`
    mutation UnacknowledgeNotifications($notificationIds: [ID!]!) {
      unacknowledgeNotifications(notificationIds: $notificationIds) {
        __typename
        updatedNotifications {
          __typename
          notification {
            id
            __typename
            updatedAt
            aknowledgedAt
          }
        }
        usersNotifications {
          __typename
          id
          unreadNotificationsCount
        }
      }
    }
  `,
  acknowledgeAllNotifications: gql`
    mutation AcknowledgeAllNotifications {
      acknowledgeAllNotifications {
        __typename
        updatedNotifications {
          __typename
          notification {
            id
            __typename
            updatedAt
            aknowledgedAt
          }
        }
        usersNotifications {
          __typename
          id
          unreadNotificationsCount
        }
      }
    }
  `,
  nudgeUser: gql`
    mutation NudgeUser($noteId: ID!, $userId: ID!) {
      nudgeUser(noteId: $noteId, userId: $userId)
    }
  `,

  requestChannelAccess: gql`
    mutation requestChannelAccess($channelId: ID!) {
      requestChannelAccess(channelId: $channelId)
    }
  `,

  requestNoteAccess: gql`
    mutation requestNoteAccess($noteId: ID!) {
      requestNoteAccess(noteId: $noteId)
    }
  `,

  notificationsCreated: gql`
    subscription notificationsCreated {
      notificationsCreated {
        __typename
        id
        createdNotifications {
          __typename
          notification {
            ...notificationAttrs
          }
          newPositionAmongAll {
            __typename
            edge {
              node {
                __typename
                id
              }
              cursor
            }
            before
            after
          }
        }
        usersNotifications {
          id
          __typename
          unreadNotificationsCount
        }
      }
    }
    ${notificationAttrsFragment}
  `,

  notificationsUpdated: gql`
    subscription notificationsUpdated {
      notificationsUpdated {
        id
        __typename
        updatedNotifications {
          __typename
          notification {
            ...notificationAttrs
          }
          newPositionAmongAll {
            edge {
              node {
                __typename
                id
              }
              cursor
            }
            before
            after
          }
        }
        usersNotifications {
          id
          __typename
          unreadNotificationsCount
        }
      }
    }
    ${notificationAttrsFragment}
  `,

  notificationsUnreadCountUpdated: gql`
    subscription notificationsUnreadCountUpdated {
      notificationsUnreadCountUpdated {
        id
        unreadNotificationsCount
      }
    }
  `,
}

export default NotificationsAPI
